import CustomerService from "../components/customor_service";
import Footer from "../components/footer";
import Navbar from "../components/navbar";
import Unit2 from "../components/unit_sekolah";

export default function UnitLayoutSekolah() {
    return (
        <>
        <Navbar/>
        <Unit2/>
        <CustomerService/>
        <Footer/>
        </>
    );
}